import { Form } from 'antd';
import styled, { css } from 'styled-components';
const LabelBase = Form.Item;
export const Label = styled(LabelBase)(() => css``);
export default Label;
